import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import { infoFormatterIntl, localeFormatter } from '../../../../utils/formatters';

export default function JuridicalView({
  applicant = {}, prefix = '', fieldsValidation, isPreview,
}) {
  const {
    legal_entity_form,
    short_name,
    full_name,
    inn,
    ogrn,
    address,
    legal_address,
    legal_entity_type,
  } = applicant;

  function PreviewJuridicalView() {
    return (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', legal_entity_type), fieldsValidation, 'applicant.legal_entity_type')}
          {infoFormatterIntl('inn', inn, fieldsValidation, `${prefix}inn`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('ogrn', ogrn, fieldsValidation, `${prefix}ogrn`)}
          {infoFormatterIntl('full_name_legal', full_name, fieldsValidation, `${prefix}full_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('short_name_legal', short_name, fieldsValidation, `${prefix}short_name`)}
          {infoFormatterIntl('legal_address', legal_address, fieldsValidation, `${prefix}legal_address`)}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('location_address', address, fieldsValidation, `${prefix}address`)}
          {/* {infoFormatterIntl('manager_first_name', applicant?.first_name, fieldsValidation, `${prefix}first_name`)} */}
        </Row>
        {/* <Row className="row-cols-2"> */}
        {/*  {infoFormatterIntl('manager_last_name', applicant?.last_name, fieldsValidation, `${prefix}last_name`)} */}
        {/*  {infoFormatterIntl('manager_middle_name', applicant?.middle_name, fieldsValidation, `${prefix}middle_name`)} */}
        {/* </Row> */}
      </>
    );
  }

  function FullJuridicalView() {
    return (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', legal_entity_type), fieldsValidation, 'applicant.legal_entity_type')}
          {infoFormatterIntl('inn', inn, fieldsValidation, `${prefix}inn`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('ogrn', ogrn, fieldsValidation, `${prefix}ogrn`)}
          {infoFormatterIntl('legal_entity_form', legal_entity_form, fieldsValidation, `${prefix}legal_entity_form`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('full_name_legal', full_name, fieldsValidation, `${prefix}full_name`)}
          {infoFormatterIntl('short_name_legal', short_name, fieldsValidation, `${prefix}short_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('legal_address', legal_address, fieldsValidation, `${prefix}legal_address`)}
          {infoFormatterIntl('location_address', address, fieldsValidation, `${prefix}address`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('manager_last_name', applicant?.last_name, fieldsValidation, `${prefix}last_name`)}
          {infoFormatterIntl('manager_first_name', applicant?.first_name, fieldsValidation, `${prefix}first_name`)}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('manager_middle_name', applicant?.middle_name, fieldsValidation, `${prefix}middle_name`)}
        </Row>
      </>
    );
  }

  return isPreview ? <PreviewJuridicalView /> : <FullJuridicalView />;
}
